// removed by extract-text-webpack-plugin
module.exports = {"main_right_content":"components-tjcx-xsxxcjcx-jxXsxxcjcx-index-main_right_content-1VFVC","table":"components-tjcx-xsxxcjcx-jxXsxxcjcx-index-table-24mBm"};


//////////////////
// WEBPACK FOOTER
// ./components/tjcx/xsxxcjcx/jxXsxxcjcx/index.css
// module id = 2322
// module chunks = 0